import React from "react";
import PageShell from "../common/page_shell";
import ContactUs from "../inner/contactus/contact_us";
import data from "../data/biodata.json";

const ContactPage = () => {
  return (
    <PageShell>
      <ContactUs contact={data?.details?.contact_details || { social_media: [] }} />
    </PageShell>
  );
};

export default ContactPage;
